import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const HeaderPortal: React.FC<{
	children: ReactNode;
	targetId?: string;
}> = ({ children, targetId = "header-left-content" }) => {
	const [target, setTarget] = useState<HTMLElement | null>(null);

	useEffect(() => {
		const headerTarget = document.getElementById(targetId);
		if (headerTarget) {
			setTarget(headerTarget);
		}
	}, [targetId]);

	return target ? createPortal(children, target) : null;
};
